var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrganizacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none",
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M28.762 10.284c3.333 2.316 5.633 6 6.1 10.25m-28.546.083a14.335 14.335 0 0 1 6-10.25M14.152 34.9a14.209 14.209 0 0 0 6.45 1.533c2.234 0 4.334-.5 6.217-1.416m-6.217-22.184a4.633 4.633 0 1 0 0-9.266 4.633 4.633 0 0 0 0 9.266ZM8.547 33.2a4.633 4.633 0 1 0 0-9.267 4.633 4.633 0 0 0 0 9.267Zm23.891 0a4.633 4.633 0 1 0 0-9.267 4.633 4.633 0 0 0 0 9.267Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrganizacion);
export default __webpack_public_path__ + "static/media/iconOrganizacion.67c6a6f974bdf59981f658a7875486f7.svg";
export { ForwardRef as ReactComponent };